function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M25.527 12.867l-.113-.48H14.98V16.8h6.233a6.239 6.239 0 0 1-6.1 4.691 7.3 7.3 0 0 1-4.913-1.954 7.013 7.013 0 0 1-2.1-4.95 7.233 7.233 0 0 1 2.054-4.945 6.988 6.988 0 0 1 4.88-1.909 6.365 6.365 0 0 1 4.152 1.618l3.138-3.122a11.1 11.1 0 0 0-7.393-2.847 11.428 11.428 0 0 0-8.083 3.289 11.382 11.382 0 0 0-3.192 7.921 11.268 11.268 0 0 0 3.068 7.792 11.7 11.7 0 0 0 8.439 3.424 10.409 10.409 0 0 0 7.581-3.187 11.194 11.194 0 0 0 2.912-7.754 12.911 12.911 0 0 0-.129-2z",
  transform: "translate(-3.656 -3.382)"
});

function SvgLogoGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22.426,
    viewBox: "0 0 22 22.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogle);
export default __webpack_public_path__ + "static/media/logo-google.9db84bbd.svg";
export { ForwardRef as ReactComponent };